import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const HznSourcingGroupDetails = () => {
  return (
    <MicroFrontEnd
      name="HznSourcingGroupDetails"
      src={apiConfig.microFrontEnds.HznSourcingGroupDetails}
    />
  )
}

export default HznSourcingGroupDetails
